import RowContent from "./containers/row-content";
import RowContentSubtitle from "./containers/row-content-subtitle";
import { FaGlobeAmericas } from 'react-icons/fa';

const LaboratoriosMercados = ({ laboratorios }) => {

    if (!laboratorios || laboratorios.length === 0) {
        return;
    }

    return <>
        <RowContent>
            <RowContentSubtitle title="Laboratórios e mercados"></RowContentSubtitle>
            {laboratorios.map((item, i) =>
                <div className="col-12 text-center" key={i}>
                    {item.ano && (
                        <blockquote><FaGlobeAmericas size={10}></FaGlobeAmericas> {item.ano}</blockquote>
                    )}
                    {item.nome?.trim() && (
                        <blockquote>{item.nome}</blockquote>
                    )}
                    {item.local?.trim() && (
                        <figcaption className="blockquote-footer">{item.local}</figcaption>
                    )}
                </div>)}
        </RowContent>
    </>
}

export default LaboratoriosMercados;
